<template><div><h1 id="info-zum-auftrag" tabindex="-1"><a class="header-anchor" href="#info-zum-auftrag"><span>Info zum Auftrag</span></a></h1>
<p>Info zum Auftrag — Erfassen eines Textes spezifisch für einen Auftrag</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Mit dieser Funktion lässt sich ein individueller Text für einen Auftrag erfassen. Das System erlaubt in den bisher erfassten Texten zublättern und vordefinierte Texte aus <RouteLink to="/referenz/refs/ft.refdata.tblwbsinfo.html" title="WBS-Infotext">WBS-Infotext</RouteLink> zu übernehmen.</p>
<p>Pfad: <code v-pre>Verkauf → Aufträge</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Text</dt>
<dd>Infotext, der auf dem Rechnungsformular gedruckt werden soll.</dd>
</dl>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refdata.auftrag.html" title="Auftrag">Auftrag</RouteLink>, <RouteLink to="/referenz/refs/ft.refdata.tblwbsinfo.html" title="WBS-Infotext">WBS-Infotexte</RouteLink></p>
</div></template>


